import styled from "styled-components";

export const DebitSummaryContainer = styled.div`
  align-content: flex-start;
  justify-content: flex-start;
`;
